import React, { FC } from "react";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";
import { Input } from "@shared/ui/input";
import { DivisionSearchSelect } from "@src/components/business-data-entry";
import { BusinessForm } from "@src/components/business-form";
import { FilterFormPanel } from "@shared/ui/form-panel";
import type { WsInvActFilter } from "../../../../../../api/wsInvActs";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import { wsInvActsFilterFormConfig, type WsInvActsFilterFormValues } from "./wsInvActsFilter.form-config";

/** Пропсы {@link WsInvActsFilterForm}. */
export type WsInvActsFilterFormProps = ListFilterPanelProps<WsInvActFilter>;

/**
 * Форма фильтра списка актов инвентаризации УП.
 */
export const WsInvActsFilterForm: FC<WsInvActsFilterFormProps> = ({ initialFilter, onApply }) => {
    const seed = useDivisionFilterSeed<WsInvActsFilterFormValues>("divisionCode");

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={seed}
            submissionMemory={{
                key: "workShop.wsInvActs.filter",
                schemaVersion: 1,
                fields: ["divisionCode"], // "stateCodes"
            }}
            formProps={{ formConfig: wsInvActsFilterFormConfig }}
            toForm={(filter) => wsInvActsFilterFormConfig.toForm(filter)}
            toDomain={(values) => wsInvActsFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="commandNum">
                        <Input {...form.field("commandNum").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="divisionCode">
                        <DivisionSearchSelect
                            {...form.field("divisionCode").getSearchSelectProps((division) => division?.Code ?? null)}
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="commandDate">
                        <Input.Date {...form.field("commandDate").getDateInputProps()} />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
